// extracted by mini-css-extract-plugin
export default {"Badge":"HelperTooltip_Badge__vofj0"};